let audioContext = null;

const getAudioContext = () => {
  const AudioCtx = window.AudioContext || window.webkitAudioContext;
  if (!AudioCtx) {
    return null;
  }
  if (!audioContext) {
    audioContext = new AudioCtx();
  }
  return audioContext;
};

export const unlockNotificationSound = () => {
  const ctx = getAudioContext();
  if (ctx?.state === 'suspended') {
    ctx.resume().catch(() => {});
  }
};

export const playNotificationAlert = () => {
  try {
    const ctx = getAudioContext();
    if (!ctx) {
      return;
    }

    if (ctx.state === 'suspended') {
      ctx.resume().catch(() => {});
    }

    const playTone = (frequency, startTime, duration) => {
      const oscillator = ctx.createOscillator();
      const gain = ctx.createGain();
      oscillator.connect(gain);
      gain.connect(ctx.destination);
      oscillator.frequency.value = frequency;
      oscillator.type = 'sine';
      gain.gain.setValueAtTime(0.22, startTime);
      gain.gain.exponentialRampToValueAtTime(0.01, startTime + duration);
      oscillator.start(startTime);
      oscillator.stop(startTime + duration);
    };

    const start = ctx.currentTime;
    playTone(880, start, 0.14);
    playTone(1100, start + 0.16, 0.14);
    playTone(1320, start + 0.32, 0.18);
  } catch (error) {
    console.warn('Bildirim sesi calinamadi:', error);
  }
};
